import "../../CSS/NewOnboading/Progresbar.css";
import wowLogo from "../../../Assets/newLogo.png";

const ProgressBar = ({
  currentStep,
  firstStep = 4,
  totalSteps = 5,
  goToStep,
  maxStepAllowed,
}) => {
  return (
    <div className="simple-progress-header">
      <div className="container-lg">
        <div className="progreess_bar_content">
          <div className="simple-logo-container">
            <img src={wowLogo} alt="Logo" className="simple-logo" />
          </div>

          <div className="simple-progress-container">
            <div className="simple-steps-wrapper">
              <div className="simple-steps">
                {Array.from({ length: totalSteps }, (_, index) => {
                  const label = index + 1; // 1..5 display
                  const actualStep = firstStep + index; // 4..8 real step
                  const isCompleted = actualStep < maxStepAllowed;
                  const isCurrent = actualStep === currentStep;
                  const isAllowed = actualStep <= maxStepAllowed;

                  return (
                    <div key={actualStep} className="simple-step-item">
                      {index > 0 && (
                        <div
                          className={`simple-step-line ${
                            actualStep <= maxStepAllowed ? "simple-active" : ""
                          }`}
                        ></div>
                      )}
                      <div
                        className={`simple-step-circle ${
                          isCompleted ? "simple-completed" : ""
                        } ${isCurrent ? "simple-current" : ""}`}
                        onClick={() =>
                          isAllowed && goToStep ? goToStep(actualStep) : null
                        }
                        style={{
                          cursor: isAllowed ? "pointer" : "default",
                          opacity: isAllowed ? 1 : 0.4,
                        }}
                      >
                        {isCompleted && !isCurrent ? (
                          <svg
                            className="simple-check-icon"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                          </svg>
                        ) : (
                          <span className="simple-step-number">{label}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="emptyDIV">EmptyDiv</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
